import React, { useRef, useCallback, useContext } from 'react'
import CruiseWhenList from './CruiseWhenList'
import SearchFormField from 'components/SearchV2/Components/SearchFormField/SearchFormField'
import { GlobalSearchDispatchContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import Group from 'components/utils/Group'
import TextButton from 'components/Luxkit/Button/TextButton'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import useToggle from 'hooks/useToggle'

interface Props {
  inputValue: string
  onChange: (values: App.CruiseGlobalFilters) => void
}

function CruiseWhenMobileInput({ inputValue, onChange }: Props) {
  const dropdownTriggerRef = useRef<HTMLButtonElement>(null)
  const [isOpen, toggleModal] = useToggle(false)
  const searchDispatch = useContext(GlobalSearchDispatchContext)

  const onClear = useCallback(() => {
    searchDispatch({ type: GlobalSearchStateActions.SET_DURATION_RANGE, min: undefined, max: undefined })
    searchDispatch({ type: GlobalSearchStateActions.SET_FLEXIBLE_MONTH_RANGE, flexibleMonths: '' })
    toggleModal()
  }, [searchDispatch, toggleModal])

  return <>
    <SearchFormField
      onClick={toggleModal}
      ref={dropdownTriggerRef}
      label="When"
      placeholder="Anytime"
      value={inputValue}
    />

    <ModalBase
      mode="drawer"
      isOpen={isOpen}
      onClose={toggleModal}
    >
      <ModalHeader
        title="When do you want to go?"
        onCloseButtonClick={toggleModal}
      />
      <ModalBody>
        <ModalContent>
          <CruiseWhenList onChange={onChange} onClose={toggleModal} />
        </ModalContent>
      </ModalBody>
      <ModalFooter>
        <Group direction="horizontal" gap={12} horizontalAlign="stretch">
          <TextButton
            kind="secondary"
            size="large"
            onClick={onClear}
          >
            Clear
          </TextButton>
          <TextButton
            kind="primary"
            size="large"
            onClick={toggleModal}
          >
            Apply
          </TextButton>
        </Group>
      </ModalFooter>
    </ModalBase>
  </>
}

export default CruiseWhenMobileInput
